import { inject } from '@angular/core';
import { FormMode } from '../core/constants';
import { UserService } from '../models/users/userService';

export class BaseComponent {
  static userService: UserService;

  FormMode = FormMode;

  constructor() {
    BaseComponent.userService = inject(UserService);
  }
}
